var alignContentMap = {
    start: "flex-start",
    center: "center",
    end: "flex-end",
    between: "space-between",
    around: "space-around",
    stretch: "stretch",
};
export default (function (_a) {
    var alignContent = _a.alignContent;
    return alignContent in alignContentMap ? "align-content: " + alignContentMap[alignContent] + ";" : "";
});
